import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import useFormStep from "./setting/useFormStep";
import ModuleFormStepThks from "./setting/thks";
import {
  ModuleTreatmentStep1,
  ModuleTreatmentStep2,
  ModuleTreatmentStep3,
  ModuleTreatmentStep4,
  ModuleTreatmentStep5,
  ModuleTreatmentStep6,
  ModuleTreatmentReference,
} from "./setting/treatment";
import {
  ModuleControlStep1,
  ModuleControlStep2,
  ModuleControlStep3,
  ModuleControlStep4,
  ModuleControlStep5,
  ModuleControlStep6,
  ModuleControlReference,
} from "./setting/control";

export default function FrontStepForm() {
  const redux_form = useSelector((state) => state.form);
  const route_navigate = useNavigate();
  const { setTabData, activeIndex, setActiveIndex, onTabChange, renderTab } =
    useFormStep();
  const titleData = {
    treatment: "當小孩被診斷為近視時，我應該讓小孩接受治療嗎?",
    control: "當我的孩子近視了，該配戴哪一種眼鏡?",
  };

  useEffect(() => {
    setTabData([
      { step: 1, label: "前言" },
      { step: 2, label: "比較" },
      { step: 3, label: "考量" },
      { step: 4, label: "了解" },
      { step: 5, label: "決定" },
      { step: 6, label: "提交" },
    ]);
  }, []);

  useEffect(() => {
    let formType = localStorage.getItem("formType"),
      formUser = localStorage.getItem("formUser");
    if (
      (redux_form.formType === "" && formType === "") ||
      (redux_form.formUser === null && formUser === null)
    ) {
      route_navigate("/chooseForm");
      return;
    }

    setActiveIndex(Number(redux_form.formStep));
  }, [redux_form.formStep]);

  useEffect(() => {
    let target = document.getElementById("main-wrap");
    target.scrollTo(0, 0);
  }, [activeIndex]);

  return (
    <>
      <div className="flex flex-column h-full">
        {[6, 7].indexOf(activeIndex) === -1 && (
          <>
            <span className="inline-block w-4rem border-bottom-4 border-main-d my-2"></span>
            <div className="text-2xl md:text-4xl text-main font-bold mb-2">
              {titleData[redux_form?.formType]}
            </div>
            <div className="border-bottom-1 border-500 -mx-3"></div>

            <span className="w-5rem text-white bg-main-d text-center px-2 border-round-md py-1 mt-2">
              {redux_form?.formType === "treatment" ? "近視治療" : "光學控制"}
            </span>

            {renderTab({ className: "my-3" })}
          </>
        )}

        {redux_form?.formType === "treatment" && (
          <>
            {activeIndex === 0 && (
              <ModuleTreatmentStep1 onTabChange={onTabChange} />
            )}
            {activeIndex === 1 && (
              <ModuleTreatmentStep2
                onTabChange={onTabChange}
                setActiveIndex={setActiveIndex}
              />
            )}
            {activeIndex === 2 && (
              <ModuleTreatmentStep3 onTabChange={onTabChange} />
            )}
            {activeIndex === 3 && (
              <ModuleTreatmentStep4 onTabChange={onTabChange} />
            )}
            {activeIndex === 4 && (
              <ModuleTreatmentStep5 onTabChange={onTabChange} />
            )}
            {activeIndex === 5 && (
              <ModuleTreatmentStep6 onTabChange={onTabChange} />
            )}
            {activeIndex === 6 && (
              <ModuleTreatmentReference onTabChange={onTabChange} />
            )}
          </>
        )}

        {redux_form?.formType === "control" && (
          <>
            {activeIndex === 0 && (
              <ModuleControlStep1 onTabChange={onTabChange} />
            )}
            {activeIndex === 1 && (
              <ModuleControlStep2
                onTabChange={onTabChange}
                setActiveIndex={setActiveIndex}
              />
            )}
            {activeIndex === 2 && (
              <ModuleControlStep3 onTabChange={onTabChange} />
            )}
            {activeIndex === 3 && (
              <ModuleControlStep4 onTabChange={onTabChange} />
            )}
            {activeIndex === 4 && (
              <ModuleControlStep5 onTabChange={onTabChange} />
            )}
            {activeIndex === 5 && (
              <ModuleControlStep6 onTabChange={onTabChange} />
            )}
            {activeIndex === 6 && (
              <ModuleControlReference onTabChange={onTabChange} />
            )}
          </>
        )}

        {activeIndex === 7 && <ModuleFormStepThks />}
      </div>
    </>
  );
}
